export const getDatePickerProps = (tzClosestAvailableDate: Date) => {
  const baseYear = tzClosestAvailableDate.getFullYear();
  const baseMonth = tzClosestAvailableDate.getMonth();
  const baseDay = tzClosestAvailableDate.getDate();

  return {
    fromYear: baseYear,
    toYear: baseYear + 3,
    fromMonth: new Date(baseYear, baseMonth),
    toMonth: new Date(baseYear + 2, baseMonth),
    fromDay: new Date(baseYear, baseMonth, baseDay),
    toDay: new Date(baseYear + 2, baseMonth, baseDay),
  };
};
